module.exports = __webpack_public_path__ + "static/media/Capo.3fb06179.jpg";